export let InventoryOrderDistributeOptions = /*#__PURE__*/function (InventoryOrderDistributeOptions) {
  InventoryOrderDistributeOptions["keepProducts"] = "TO_INVENTORY_AND_KEEP";
  InventoryOrderDistributeOptions["sendProducts"] = "TO_INVENTORY_AND_DISTRIBUTE";
  return InventoryOrderDistributeOptions;
}({});